// app/constants/profileKeys.js
// Centralized AsyncStorage key constants — every professional-side screen
// reads/writes via these. Keys are user-scoped where data is user-specific,
// and global where shared (e.g. auth tokens).

const userScopedKey = (key, userId) => `prof_${userId || 'default'}__${key}`;

export const PROF_KEYS = {
  // ── Identity / auth ─────────────────────────────────────────────────────
  USER_TOKEN: 'userToken',
  AUTH_TOKEN: 'auth_token',
  USER_ID: 'user_id',
  USER_EMAIL: 'userEmail',
  COMPANY_ID: 'company_id',

  // ── Profile data (scoped by user) ───────────────────────────────────────
  profile: (uid) => userScopedKey('profile', uid),
  resumeData: (uid) => userScopedKey('resume_data', uid),
  portfolioData: (uid) => userScopedKey('portfolio_data', uid),
  skillsData: (uid) => userScopedKey('skills_data', uid),

  // ── Resume / cover letter libraries ─────────────────────────────────────
  resumes: (uid) => userScopedKey('resumes', uid),
  coverLetters: (uid) => userScopedKey('cover_letters', uid),
  activeResumeId: (uid) => userScopedKey('active_resume_id', uid),
  resumeAnalysis: (uid, resumeId) => userScopedKey(`resume_analysis_${resumeId}`, uid),

  // ── ATS / scoring ───────────────────────────────────────────────────────
  atsResult: (uid) => userScopedKey('ats_result', uid),
  atsHistory: (uid) => userScopedKey('ats_history', uid),
  aiRecommendations: (uid) => userScopedKey('ai_recommendations', uid),

  // ── Skills assessment / progress ────────────────────────────────────────
  skillAssessments: (uid) => userScopedKey('skill_assessments', uid),
  skillProgress: (uid) => userScopedKey('skill_progress', uid),
  enrolledCourses: (uid) => userScopedKey('enrolled_courses', uid),

  // ── Settings / preferences ──────────────────────────────────────────────
  profileSettings: (uid) => userScopedKey('profile_settings', uid),
  jobPreferences: (uid) => userScopedKey('job_preferences', uid),

  // ── Sync timestamps ─────────────────────────────────────────────────────
  lastProfileSync: (uid) => userScopedKey('last_profile_sync', uid),
  lastResumeSync: (uid) => userScopedKey('last_resume_sync', uid),
};

export default PROF_KEYS;
